import { createContext } from "react";

export const ScrollWipeContext = createContext(null);
